import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { TIME_FORMAT } from '@/app/interfaces/time-format.enum';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-input-timepicker',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule,MatInputModule,FormsModule,ReactiveFormsModule,NgxMaterialTimepickerModule,MatIconModule],
  templateUrl: './input-timepicker.component.html',
  styleUrl: './input-timepicker.component.css'
})
export class InputTimepickerComponent implements OnInit {
  @Input() label: string = '';
  @Input() format: TIME_FORMAT = TIME_FORMAT.TWENTY_FOUR;
  @Input() required: boolean = false;
  @Input() placeholder: string = '';
  @Input() readonly: boolean = false;
  @Input() type: string = 'text';
  @Input() value: string = '';
  @Input() errorMessage: string = 'This field is required';
  @Input() control: FormControl = new FormControl('');
  @Output() valueChange = new EventEmitter<string>();

  ngOnInit(): void {
    // Only initialize control if it wasn't passed as an input
    if (!this.control) {
      this.control = new FormControl(this.value, this.required ? Validators.required : null);
    } 
  }

  timePicker(): void {
    console.log("time",this.control.value);
    this.valueChange.emit(this.control.value);
  }

}
